import { createElement } from 'react';

import { listIcon } from '../model/visuals';

/** The icon a list was given (lucide; an unknown name shows the plain list icon). */
export function ListIcon({ name, className }: { name: string | null | undefined; className?: string }) {
  return createElement(listIcon(name), { className, 'aria-hidden': true });
}
